import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import VehicleShowcase from "../components/VehicleShowcase";
import TouristGallery from "../components/TouristGallery";
import BookingForm from "../components/BookingForm";
import BusinessSection from "../components/BusinessSection";
import ReviewsSection from "../components/ReviewsSection";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

export default function Home() {
  return (
    <div className="bg-black text-white min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <BusinessSection />
        <BookingForm />
        <VehicleShowcase />
        <TouristGallery />
        <ReviewsSection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
